export type CapacityBandClasses = {
  cell: string;
  text: string;
  bold: boolean;
};

/**
 * Maps a technician's Approved hours to spare-capacity highlight classes.
 * Below a full 8h shift the amber background deepens toward zero. At or above
 * 8h there is no highlight (plain slate text). The 8h mark is a visual
 * threshold only, not a per-day/per-week comparison.
 */
export function getCapacityBandClasses(
  approvedHours: number
): CapacityBandClasses {
  if (approvedHours >= 8)
    return { cell: "", text: "text-slate-600", bold: false };
  if (approvedHours >= 6)
    return { cell: "bg-amber-50", text: "text-amber-950", bold: true };
  if (approvedHours >= 4)
    return { cell: "bg-amber-100", text: "text-amber-950", bold: true };
  if (approvedHours >= 2)
    return { cell: "bg-amber-200", text: "text-amber-950", bold: true };
  return { cell: "bg-amber-300", text: "text-amber-950", bold: true };
}
